<template>
  <div class="results-map">
    <ClientOnly>
      <LazyMapsMultiple :features="features" @close="$emit('close')" />
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
import type { ApiSearchResponseItem } from '~~/layers/legacy-search/app/types'
import { notNullish } from '@vueuse/core'
import type { MapPoiFeature } from '~/helpers/maps'

const props = defineProps<{
  results: ApiSearchResponseItem[]
}>()

defineEmits(['close'])

const features = computed<MapPoiFeature[]>(() => {
  return props.results
    .map((v) => {
      if (v.latlon) {
        return {
          id: v.nid as string,
          title: v.title,
          lat: v.latlon![0]!,
          lon: v.latlon![1]!,
          url: v.url,
          media: v.image,
        }
      }
      return null
    })
    .filter(notNullish)
})
</script>

<style>
@reference '~/assets/css/tailwind.css';
.results-map {
  @apply h-full;
}

.results-map-close-button {
  @apply absolute p-0;
  top: 1rem;
  right: 1rem;
  z-index: 1000000;
}
</style>
